(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.lc-chero a[data-cta-anchor="true"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !Shopify.designMode) return;
  try {
    
// v14 — Catalog B2 filter (AJAX section render) + format tabs (AJAX) + scroll preserve.
(function () {
  var section = document.querySelector('[data-section-id]');
  var grid = document.querySelector('[data-cgrid-products]');
  if (!grid) return;

  var sectionEl = grid.closest('.lc-cgrid');
  if (!sectionEl) return;
  var sectionId = sectionEl.getAttribute('data-section-id');
  var isCatalog = sectionEl.getAttribute('data-is-catalog') === 'true';

  // Pull preferred password query so AJAX fetch preserves it (preview mode).
  function preservePasswordParam(url) {
    var current = new URLSearchParams(window.location.search);
    var pw = current.get('password');
    if (pw) {
      var u = new URL(url, window.location.origin);
      if (!u.searchParams.has('password')) u.searchParams.set('password', pw);
      return u.pathname + '?' + u.searchParams.toString();
    }
    return url;
  }

  // ── Shared AJAX fetch + DOM swap (preserves scrollY) ──────────────
  // R3 PERF — sessionStorage cache for filter swap responses. After first fetch
  // of a given URL, subsequent toggles of the same filter combo render instantly
  // from cache (typical bounce: user clicks chip A → chip B → back to chip A → cached).
  // TTL: per-session (cleared on tab close). Cache size cap: 8 entries to bound memory.
  /* v115 — ONBELLEK ANAHTARI CIP SATIRINDAN TURETILIR.
     Neden: bu iki onbellek, cip satirini ICEREN HTML'i saklıyor. Cip satiri degistiginde
     (v114'te All kaldirildi + sira degisti) eski kayitlar hala eski satiri servis ediyordu —
     kullanici baska bir filtreye basinca "All" geri geliyordu. Sabit bir 'v1' etiketini elle
     artirmak bu hatanin her markup degisiminde tekrarlamasi demek. Bunun yerine anahtar,
     SAYFADA DURAN cip satirinin kendisinden hesaplanir: satir degisirse anahtar degisir ve
     eski kayit hicbir zaman okunmaz. Elle bakim gerekmez. */
  function lcCipSurumu() {
    try {
      var els = document.querySelectorAll('[data-chip-group] a');
      var s = '';
      for (var i = 0; i < els.length; i++) { s += els[i].textContent.trim() + '|'; }
      var h = 0;
      for (var j = 0; j < s.length; j++) { h = ((h << 5) - h + s.charCodeAt(j)) | 0; }
      return (h >>> 0).toString(36);
    } catch (e) { return '0'; }
  }
  var LC_SUR = lcCipSurumu();
  var SWAP_CACHE_KEY = 'lc-cgrid-swap-' + LC_SUR;
  function swapCacheGet(url) {
    try { var c = JSON.parse(sessionStorage.getItem(SWAP_CACHE_KEY) || '{}'); return c[url] || null; }
    catch (_) { return null; }
  }
  function swapCacheSet(url, html) {
    try {
      var c = JSON.parse(sessionStorage.getItem(SWAP_CACHE_KEY) || '{}');
      var keys = Object.keys(c);
      if (keys.length >= 8) delete c[keys[0]]; // FIFO eviction
      c[url] = html;
      sessionStorage.setItem(SWAP_CACHE_KEY, JSON.stringify(c));
    } catch (_) { /* quota / disabled — silent */ }
  }

  /* DISARIYA ACILDI (2026-08-21). Kategori seridi ayni gecisi yapmak zorunda ve
     ikinci bir takas kopyasi yazmak, ayni gercegin iki kaynagi demekti: onbellek,
     yapiskan cubuk, is-loading durumu ve scroll korumasi burada duruyor. Serit
     `window.lcGridSwap(yol)` cagirir; fonksiyon YOKSA duz gezinmeye duser, yani
     bu bir bagimlilik degil bir iyilestirme. */
  function fetchAndSwap(newPath, opts) {
    opts = opts || {};
    var url = new URL(newPath, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    var fetchUrl = preservePasswordParam(url.pathname + '?' + url.searchParams.toString());
    sectionEl.classList.add('is-loading');
    // Try cache first — instant response if same URL fetched this session
    var cached = swapCacheGet(fetchUrl);
    var fetchPromise = cached
      ? Promise.resolve(cached)
      : fetch(fetchUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) { swapCacheSet(fetchUrl, html); return html; });
    return fetchPromise
      .then(function (html) {
        // Response is the section partial HTML. Parse and swap.
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newSection = tmp.querySelector('.lc-cgrid') || tmp.firstElementChild;
        if (!newSection) return;
        // Replace inner content (preserves the outer wrapper attached event listeners on document)
        var newContainer = newSection.querySelector('.lc-cgrid__container');
        var curContainer = sectionEl.querySelector('.lc-cgrid__container');
        if (newContainer && curContainer) {
          curContainer.innerHTML = newContainer.innerHTML;
        }
        // Update is-catalog / data-active-* attributes on section
        if (newSection.hasAttribute('data-is-catalog')) {
          sectionEl.setAttribute('data-is-catalog', newSection.getAttribute('data-is-catalog'));
        }
        // v54 — Also swap the sticky filter bar inner (crumb + count). The sticky
        // bar lives OUTSIDE the section element on the page, but the section.liquid
        // file renders both, so the response contains both.
        var newSticky = tmp.querySelector('[data-cgrid-sticky]');
        var curSticky = document.querySelector('[data-cgrid-sticky]');
        if (newSticky && curSticky) {
          curSticky.innerHTML = newSticky.innerHTML;
        }
        // Update history without scroll change
        if (opts.pushUrl) {
          history.replaceState(null, '', preservePasswordParam(opts.pushUrl));
        }
      })
      .catch(function (e) { console.warn('[v14 AJAX] fetch failed:', e); })
      .finally(function () { sectionEl.classList.remove('is-loading'); });
  }

  // ── Catalog B2: read state from path + ?super query ───────────────
  window.lcGridSwap = fetchAndSwap;

  /* KATEGORI SECILDI, CERCEVE SECILMEDI -> CANVAS (Mert 2026-09-03:
     "kullanici eger category secip frame secmezse default canvas secili gelsin").

     NEDEN YONLENDIRME DEGIL: 2026-08-21'de ciplak koleksiyon adresini
     `location.replace` ile /metal-framed'e goturen bir yonlendirme BILEREK
     kaldirildi — kanonik adres noindex bir adrese yonlendiriliyordu ve Googlebot
     JS calistirir. Burada yonlendirme YOK: sayfa kendi HTML'iyle aciliyor
     (tarayicinin ve botun gordugu ilk cikti degismedi), yalnizca izgara parcasi
     canvas surumuyle takas ediliyor ve adres `replaceState` ile guncelleniyor.
     Ikinci bir tam sayfa yuklemesi olmuyor.

     UST MENU CIPLAK KALIYOR ve bu da bilincli: kanonik koleksiyon sayfalarinin
     ic baglantisi menuden geliyor. Menuyu /canvas'a baglamak o baglantilari
     keserdi.

     UC KAPI: (a) yalniz TEKIL koleksiyon sayfasi — /collections/all ve katalog
     disarida; (b) adreste zaten bir format varsa dokunulmaz (kullanicinin secimi);
     (c) kullanici formati ELIYLE kaldirdiysa (`lcFmtCleared`) dokunulmaz — o niyeti
     ezmek kaldirma dugmesini islevsiz birakirdi.
     DORDUNCU KAPI OLCUME DAYALI: koleksiyonda canvas urunu YOKSA takas edilmez;
     bos bir izgara gostermek, dolu bir izgaradan kotudur. Canvas hapinin
     `is-empty` sinifi bunu zaten soyluyor, yeni bir sayac uretilmedi. */
  /* ── VARSAYILAN-CANVAS TAKASI KALDIRILDI (Mert 2026-09-10) ──────────────────
     Birebir: "bi de collection'da default canvas secme mevzusunu kaldir,
     collection aciyorum collection yazisi gozukmuyo".

     BELIRTI DOGRU, SEBEP USTTEKI BLOGUN GORMEDIGI YERDEYDI — olculdu 2026-09-10,
     canli iki adres:
       /collections/neutral-abstract-wall-art         -> lc-cbody VAR,
           "Elsewhere in the catalogue" 2 · "From the journal" 1 · robots yok
       /collections/neutral-abstract-wall-art/canvas  -> lc-cbody YOK,
           ikisi de 0 · robots: noindex, follow
     Sablonun kendi kurali bunu zaten soyluyordu (bu dosyada, YUVA 2): yol dorde
     ciktiginda gorunum bir ALT KUME sayilir ve izgara alti icerik BASILMAZ. Yani
     takas yalnizca izgarayi degistirmiyordu — koleksiyonun KENDI METNINI, SSS'ini,
     komsu koleksiyon kartlarini ve journal baglantilarini da gorunmez kiliyordu.
     Bu bedel 2026-09-03'te olculmemisti.

     USTTEKI BLOK SILINMEDI: 2026-09-03'te Mert format secilmediginde canvas
     gelmesini istemisti ve istegin gerekcesi hala anlasilir. Degisen sey istegin
     BEDELININ artik olculmus olmasi.

     UCUNCU KEZ AYNI YERE DONULDU, ve zincir kayda deger:
       2026-08-21  location.replace -> /metal-framed   KALDIRILDI
                   (noindex adrese yonlendirme; Googlebot JS calistirir)
       2026-09-03  fetchAndSwap     -> /canvas         EKLENDI
                   (yonlendirme yok, yalniz izgara takasi; SEO bedeli bu yuzden
                    YOK SANILDI)
       2026-09-10  fetchAndSwap     -> /canvas         KALDIRILDI
                   (bedel yonlendirmede degil ALT KUME KURALINDA imis)
     DERS: bir mekanizmayi degistirmek, o mekanizmanin BAGLI OLDUGU kurali
     degistirmez. Yonlendirmeyi takasa cevirmek adres davranisini duzeltti;
     adresin "filtreli" SAYILMASINI duzeltmedi — ve gorunmeyen sey oydu.

     VARSAYILAN FORMAT NEREYE GITTI: navigasyona, 2026-08-21'de tasindigi yere.
     Kategori seridi ve menu zaten filtreli adrese bagli, yani formatini secmek
     isteyen kullanici tek yuklemede oraya varir. Ciplak adres — Google'in ve
     okurun gordugu adres — tam icerikli kalir. */

  function readCatalogState() {
    var path = window.location.pathname.replace(/\/+$/, '');
    var m = path.match(/^\/collections\/all\/([^\/?]+)/);
    var tags = m ? m[1].split('+') : [];
    var CATS = ['abstract','surreal','studio-editions','boho','statement','pop-art','bar-art','wanderlust','vintage','contemporary'];
    var FMTS = ['canvas','metal-framed','wooden-framed','framed-canvas'];
    var fmt = tags.filter(function (t) { return FMTS.indexOf(t) !== -1; })[0] || 'canvas';
    var params = new URLSearchParams(window.location.search);
    var sup = (params.get('super') || '').toLowerCase();
    var atm = ['abstract','surreal','studio-editions','boho'];
    var detectedCat = tags.filter(function (t) { return CATS.indexOf(t) !== -1; })[0];
    if (sup !== 'atmospheric' && sup !== 'affiche') {
      sup = detectedCat && atm.indexOf(detectedCat) !== -1 ? 'atmospheric' : 'affiche';
    }
    // v16: Default cat depends on the (now-resolved) super — Atmospheric→abstract, Affiche→pop-art.
    var cat = detectedCat || (sup === 'atmospheric' ? 'abstract' : 'pop-art');
    return { super: sup, cat: cat, fmt: fmt };
  }

  function buildCatalogUrl(state) {
    return '/collections/all/' + state.cat + '+' + state.fmt + '?super=' + state.super;
  }

  // ── v18 İŞ 2 — DOM-only filter helpers (no AJAX for cat/fmt within same super) ──
  var ATM = ['abstract','surreal','studio-editions','boho'];
  var AFF = ['statement','pop-art','wanderlust','vintage','contemporary'];
  var ATM_DEFAULT_CAT = 'abstract';
  var AFF_DEFAULT_CAT = 'pop-art';
  var FMT_LABELS = { 'canvas': 'Canvas', 'metal-framed': 'Metal', 'wooden-framed': 'Wooden', 'framed-canvas': 'Framed Canvas' };
  var CAT_LABELS = { 'abstract': 'Abstract', 'surreal': 'Surreal', 'studio-editions': 'Studio',
                     'boho': 'Boho', 'statement': 'Typography', 'pop-art': 'Pop Art',
                     'wanderlust': 'Wanderlust', 'vintage': 'Vintage', 'contemporary': 'Contemporary' };
  var SUPER_LABEL = { 'atmospheric': 'Atmospheric', 'affiche': 'Affiche' };

  function countMatching(cat, fmt) {
    return sectionEl.querySelectorAll('[data-cgrid-products] > .lc-cgrid__product-wrap[data-cat="' + cat + '"][data-fmt="' + fmt + '"]').length;
  }

  function domFilter(state) {
    var wraps = sectionEl.querySelectorAll('[data-cgrid-products] > .lc-cgrid__product-wrap');
    var n = 0;
    wraps.forEach(function (w) {
      var match = w.getAttribute('data-cat') === state.cat && w.getAttribute('data-fmt') === state.fmt;
      w.style.display = match ? '' : 'none';
      if (match) n++;
    });
    return n;
  }

  function updateChipsActive(state) {
    // CATEGORY chips
    sectionEl.querySelectorAll('[data-chip-group="cat"] .lc-cgrid__b2-chip').forEach(function (c) {
      c.classList.toggle('is-active', c.getAttribute('data-cat') === state.cat);
    });
    // FORMAT chips — update is-active + is-empty based on current cat's counts
    sectionEl.querySelectorAll('[data-chip-group="fmt"] .lc-cgrid__b2-chip').forEach(function (c) {
      var fmt = c.getAttribute('data-fmt');
      var n = countMatching(state.cat, fmt);
      c.classList.toggle('is-active', fmt === state.fmt);
      c.classList.toggle('is-empty', n === 0);
      if (n === 0) c.setAttribute('disabled', '');
      else c.removeAttribute('disabled');
      c.setAttribute('data-count', String(n));
    });
    // Count badge
    var countEl = sectionEl.querySelector('[data-cgrid-count]');
    if (countEl) {
      var total = countMatching(state.cat, state.fmt);
      countEl.textContent = total + ' works';
    }
    // v23 İŞ 3 — MATERIAL row image+text swap on format change.
    // URLs pre-baked by Liquid into data-{fmt}-frame / data-{fmt}-print attrs
    // (Shopify file_img_url with auth hash — JS reads, doesn't construct).
    var mat = sectionEl.querySelector('[data-cgrid-mat]');
    if (mat) {
      var fmtKey = (state.fmt === 'metal-framed') ? 'metal'
                 : (state.fmt === 'wooden-framed') ? 'wood'
                 : (state.fmt === 'framed-canvas') ? 'framed'
                 : 'canvas';
      var frameUrl = mat.getAttribute('data-' + fmtKey + '-frame');
      var printUrl = mat.getAttribute('data-' + fmtKey + '-print');
      var matTextStr = mat.getAttribute('data-' + fmtKey + '-text');
      var thumbFrame = mat.querySelector('[data-mat-thumb="frame"]');
      var thumbPrint = mat.querySelector('[data-mat-thumb="print"]');
      var matText = mat.querySelector('.lc-cgrid__b2-mat-text');
      if (thumbFrame && frameUrl) thumbFrame.src = frameUrl;
      if (thumbPrint && printUrl) thumbPrint.src = printUrl;
      if (matText && matTextStr) matText.textContent = matTextStr;
    }
    // Update data-active-* on the wrapper so the next AJAX swap reflects the latest state
    var wrap = sectionEl.querySelector('[data-cgrid-b2]');
    if (wrap) {
      wrap.setAttribute('data-active-super', state.super);
      wrap.setAttribute('data-active-cat', state.cat);
      wrap.setAttribute('data-active-fmt', state.fmt);
    }
  }

  function updateBoxes(state) {
    sectionEl.querySelectorAll('.lc-cgrid__b2-box').forEach(function (b) {
      b.classList.toggle('is-selected', b.getAttribute('data-super') === state.super);
    });
  }

  function rebuildCatChips(state) {
    // Replace the CATEGORY chip list to match the active super's cat order.
    var container = sectionEl.querySelector('[data-chip-group="cat"]');
    if (!container) return;
    var cats = state.super === 'atmospheric' ? ATM : AFF;
    container.innerHTML = '';
    cats.forEach(function (cat) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lc-cgrid__b2-chip' + (cat === state.cat ? ' is-active' : '');
      btn.setAttribute('data-cat', cat);
      btn.textContent = CAT_LABELS[cat] || cat;
      container.appendChild(btn);
    });
  }

  function updateUrl(state) {
    var u = new URL(window.location.href);
    u.pathname = '/collections/all/' + state.cat + '+' + state.fmt;
    u.searchParams.set('super', state.super);
    history.replaceState(null, '', u.pathname + u.search + u.hash);
  }

  function updateStickyBar(state) {
    var bar = document.querySelector('[data-cgrid-sticky]');
    if (!bar) return;
    var sup = SUPER_LABEL[state.super] || state.super;
    var cat = CAT_LABELS[state.cat] || state.cat;
    var fmt = FMT_LABELS[state.fmt] || state.fmt;
    var crumbEl = bar.querySelector('[data-cgrid-sticky-crumb]');
    var countEl = bar.querySelector('[data-cgrid-sticky-count]');
    if (crumbEl) crumbEl.textContent = sup + ' · ' + cat + ' · ' + fmt;
    if (countEl) {
      var n = countMatching(state.cat, state.fmt);
      countEl.textContent = n + ' works';
    }
  }

  function setCatFmt(state) {
    // Single source: apply DOM filter, update all UI bindings, push URL.
    domFilter(state);
    updateChipsActive(state);
    updateBoxes(state);
    updateUrl(state);
    updateStickyBar(state);
  }

  // ── v21 Tur 1 — Full-load enhancement (Shopify Liquid 50-cap bypass) ──
  //
  // v23 YOL 2 mechanism (replaces v21 products.json + JS-card builder).
  // For categories where Liquid's 50-product cap truncated the server-side
  // render (detected via [data-cgrid-b2][data-loading="true"] attr placed by
  // Liquid runtime check `cat_collection.products_count > 50`), the JS fetches
  // /collections/{cat_handle}/{fmt}?section_id=collection-product-grid which
  // returns the section's rendered HTML for ALL matching products with FULL
  // Liquid card features (swatches, price localization, alt text, ARIA).
  //
  // Strategy: don't build cards client-side. Use Liquid's own template via
  // section-rendering API as the single source of card truth. Eliminates the
  // v21 JS-card-vs-Liquid-card divergence and resolves v21 FLAGs 1+3.
  //
  // sessionStorage cache: per-(handle, fmt) HTML response cached for the
  // session. Repeat visits to same combo = instant (no network).

  function needsFullLoad(b2El) {
    return !!(b2El && b2El.getAttribute('data-loading') === 'true');
  }

  // Map cat tag → smart-collection handle (parametric — no per-cat code paths).
  var CAT_TO_HANDLE = {
    'abstract':        'abstract-art',
    'surreal':         'surreal-art',
    'studio-editions': 'studio-editions',
    'boho':           'boho',
    'statement':       'typography-art',
    'pop-art':         'pop-art',
    'wanderlust':      'wanderlust',
    'vintage':         'vintage-art',
    'contemporary':    'contemporary-art'
  };

  function fetchSectionCards(handle, fmt) {
    var cacheKey = 'laco-section-' + lcCipSurumu() + '-' + handle + '-' + fmt;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) return Promise.resolve({ html: cached, fromCache: true });
    } catch (e) {}
    var url = '/collections/' + handle + '/' + fmt + '?section_id=collection-product-grid';
    url = preservePasswordParam(url);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try { sessionStorage.setItem(cacheKey, html); } catch (e) {}
        return { html: html, fromCache: false };
      });
  }

  function parseAndAppendCards(html, cat, fmt) {
    // Extract individual `.lc-cgrid__product-wrap` divs (section-render of
    // /collections/{handle}/{fmt} is in non-catalog mode → wraps use the
    // `data-product-tags` attribute). We translate to catalog mode by adding
    // `data-cat` + `data-fmt`. Cards inside are full Liquid `best-seller-card`
    // markup → keep as-is (swatches, price, ARIA preserved).
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var srcWraps = tmp.querySelectorAll('.lc-cgrid__product-wrap');
    var grid = sectionEl.querySelector('[data-cgrid-products]');
    if (!grid) return 0;
    // Dedupe by product id
    var existing = {};
    grid.querySelectorAll('.lc-bs-card[data-product-id]').forEach(function (c) {
      existing[c.getAttribute('data-product-id')] = true;
    });
    var state = readCatalogState();
    var added = 0;
    srcWraps.forEach(function (w) {
      var card = w.querySelector('.lc-bs-card[data-product-id]');
      if (!card) return;
      var pid = card.getAttribute('data-product-id');
      if (existing[pid]) return;
      // Determine pfmt from product tags (data-product-tags) — same as
      // server-side detection.
      var pfmt = fmt;  // section URL filters to this fmt already
      // Strip the non-catalog `data-product-tags` attr; add catalog attrs.
      w.removeAttribute('data-product-tags');
      w.setAttribute('data-cat', cat);
      w.setAttribute('data-fmt', pfmt);
      // Visibility: section response IS for current (cat, fmt) — make visible.
      if (cat === state.cat && pfmt === state.fmt) {
        w.style.display = '';
      } else {
        w.style.display = 'none';
      }
      grid.appendChild(w);
      added++;
    });
    return added;
  }

  function rehydrateIfNeeded() {
    var b2 = sectionEl.querySelector('[data-cgrid-b2]');
    if (!needsFullLoad(b2)) return Promise.resolve();
    var state = readCatalogState();
    var handle = CAT_TO_HANDLE[state.cat];
    if (!handle) {
      console.warn('[v23 rehydrate] no handle for cat=' + state.cat);
      return Promise.resolve();
    }
    // Pre-fetch ALL 3 formats in parallel for this cat → subsequent fmt
    // chip clicks resolve instantly (cards already in DOM). For Abstract
    // (the only >50 cat today), this is 3 × ~1.2s parallel ≈ ~1.5s total.
    var fmts = ['canvas', 'metal-framed', 'wooden-framed', 'framed-canvas'];
    return Promise.all(fmts.map(function (f) {
      return fetchSectionCards(handle, f).then(function (res) {
        return { fmt: f, html: res.html, fromCache: res.fromCache };
      });
    })).then(function (results) {
      var totalAdded = 0;
      var cacheHits = 0;
      results.forEach(function (r) {
        totalAdded += parseAndAppendCards(r.html, state.cat, r.fmt);
        if (r.fromCache) cacheHits++;
      });
      var stickyBar = document.querySelector('[data-cgrid-sticky]');
      domFilter(state);
      updateChipsActive(state);
      updateStickyBar(state);
      if (b2) b2.removeAttribute('data-loading');
      if (stickyBar) stickyBar.removeAttribute('data-loading');
      console.log('[v23 YOL 2] cat=' + state.cat + ' added=' + totalAdded + ' cacheHits=' + cacheHits + '/3');
    }).catch(function (e) {
      console.warn('[v23 rehydrate] failed:', e);
      // Degrade: unmask anyway so user sees server-rendered subset rather than blank.
      if (b2) b2.removeAttribute('data-loading');
      var stickyBar2 = document.querySelector('[data-cgrid-sticky]');
      if (stickyBar2) stickyBar2.removeAttribute('data-loading');
    });
  }

  // ── v54 — Filter chip click handler: AJAX swap with scroll position preserved ──
  // R3 PERF — instant filter switch via 3-layer speedup:
  //   1. PREFETCH on pointerenter/touchstart — starts fetch before user clicks (~200ms head start)
  //   2. CACHE — re-tap on previously visited filter = instant (swapCacheGet hit)
  //   3. OPTIMISTIC UI — chip active state flips immediately on click; fade only if fetch > 150ms
  //
  // Chips are anchor <a> links (so right-click / open-in-new-tab still works), but on plain click
  // we intercept and do an in-place section swap via Shopify's Section Rendering API. Scroll
  // position preserved exactly. Works on both b2 panel AND sticky filter bar (delegated).

  // PREFETCH on hover/touch — warms swapCache for the URL user is about to tap
  function prefetchChip(chip) {
    if (!chip || chip.getAttribute('aria-disabled') === 'true') return;
    if (chip.classList.contains('is-active')) return;
    var href = chip.getAttribute('href');
    if (!href) return;
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    var fetchUrl = preservePasswordParam(url.pathname + '?' + url.searchParams.toString());
    if (swapCacheGet(fetchUrl)) return; // already cached
    fetch(fetchUrl, { credentials: 'same-origin', priority: 'low' })
      .then(function (r) { return r.text(); })
      .then(function (html) { swapCacheSet(fetchUrl, html); })
      .catch(function () {});
  }
  document.addEventListener('pointerenter', function (e) {
    if (e.target && e.target.closest) prefetchChip(e.target.closest('.lc-cgrid__b2-chip--fmt'));
  }, true);
  document.addEventListener('touchstart', function (e) {
    if (e.target && e.target.closest) prefetchChip(e.target.closest('.lc-cgrid__b2-chip--fmt'));
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.lc-cgrid__b2-chip--fmt');
    if (!chip) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (chip.getAttribute('aria-disabled') === 'true') return;
    if (chip.classList.contains('is-active')) { e.preventDefault(); return; }
    var href = chip.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    var preservedY = window.scrollY;
    // OPTIMISTIC: flip chip active state instantly so user sees the response
    chip.parentNode.querySelectorAll('.lc-cgrid__b2-chip--fmt.is-active').forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');
    fetchAndSwap(href, { pushUrl: href }).then(function () {
      window.scrollTo(0, preservedY);
      if (typeof updateStickyVisibility === 'function') updateStickyVisibility();
    });
  });

  // ── Manual scroll restoration (avoids browser auto-scroll on history.replaceState) ──
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // ── v21 Tur 1 — Rehydrate full-load cats on init (kicks off products.json fetch). ──
  // v53: rehydrate is catalog-only and was tied to the DOM-only filter approach
  // (now removed). Keep the guard but the call is effectively a no-op for the
  // unified paginated grid.
  if (isCatalog) {
    rehydrateIfNeeded();
  }

  // ── v19 — Sticky filter bar: show when full filter panel scrolls out ──
  // v53: UN-GATED — now runs on catalog + individual collection pages.
  //
  // Dual mechanism for reliability:
  //   1. Scroll listener (primary, deterministic): bar visible when
  //      window.scrollY > panelBottom. Always fires reliably.
  //   2. IntersectionObserver (secondary, efficient): same outcome, lighter
  //      on devices that throttle scroll. Used as a passive corroborator.
  //
  // Previous v18 used IO only; combined with z-index 90 < header z-index 100
  // + top:0 (same as header) the bar was rendered behind the header and
  // never observed by the user. v19 puts the bar at top:72px (below header)
  // with z-index 105 (above header) — now visually correct.
  // v53: `if (isCatalog)` gate removed — bar now also tracks scroll on
  // individual collection pages (per Mert: "sticky filter logic stays" + apply everywhere).
  {
    var stickyBar = document.querySelector('[data-cgrid-sticky]');
    var b2 = sectionEl.querySelector('[data-cgrid-b2]');
    if (!stickyBar || !b2) return;

    // v23 İŞ 4: HEADER_OFFSET matches the sticky bar's top: 96px (desktop)
    // so the bar becomes visible the moment the filter panel scrolls fully
    // above the bar's top edge. Mobile sticky CSS overrides bar to top:60px;
    // browser layout is forgiving — 96 here is a defensible upper bound.
    var HEADER_OFFSET = 96;

    function updateStickyVisibility() {
      // Bar visible iff the bottom of the filter panel is above the header offset.
      var rect = b2.getBoundingClientRect();
      var shouldShow = rect.bottom <= HEADER_OFFSET;
      if (shouldShow) {
        if (!stickyBar.classList.contains('is-visible')) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      } else {
        if (stickyBar.classList.contains('is-visible')) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      }
    }

    // Throttled scroll listener (rAF-based, ~60fps cap)
    var scrollTicking = false;
    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateStickyVisibility();
        scrollTicking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Initial check (in case page loads scrolled)
    updateStickyVisibility();

    // IntersectionObserver as secondary (defense in depth — if scroll listener
    // is throttled by the browser, IO still fires on each pixel boundary).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          } else if (e.boundingClientRect.bottom <= HEADER_OFFSET) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0, rootMargin: '-' + HEADER_OFFSET + 'px 0px 0px 0px' });
      io.observe(b2);
    }

    // Sticky toggle: smooth-scroll back to the full filter panel.
    stickyBar.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cgrid-sticky-toggle]');
      if (!t) return;
      e.preventDefault();
      var anchor = sectionEl.querySelector('[data-cgrid-b2]');
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.lc-hero-slider').forEach(function (slider) {
    var track = slider.querySelector('.lc-hero-slider__track');
    var slides = slider.querySelectorAll('.lc-hero-slider__slide');
    var dots = slider.querySelectorAll('.lc-hero-slider__dot');
    var navs = slider.querySelectorAll('.lc-hero-slider__nav');
    var viewport = slider.querySelector('.lc-hero-slider__viewport');
    if (!track || slides.length < 2) return;

    var totalDom = slides.length;             // includes clone (e.g. 12)
    var totalLogical = dots.length;            // real slides (e.g. 11)
    var domPos = 0;                            // 0..totalDom-1
    var logicalIdx = 0;                        // 0..totalLogical-1
    var autoplay = slider.dataset.autoplay !== 'false';
    var interval = parseInt(slider.dataset.interval, 10) || 6000;
    // v90/v95 — Slide 0 is the Signature reel; advance before the end-card freeze so
    // the slider keeps momentum. Desktop holds 12s; mobile advances 1s earlier (11s).
    var isMobileHero = window.matchMedia('(max-width: 768px)').matches;
    var SLIDE0_ADVANCE_SEC = isMobileHero ? 11 : 12;
    var SLIDE0_INTERVAL = SLIDE0_ADVANCE_SEC * 1000;
    function intervalFor(idx) { return idx === 0 ? SLIDE0_INTERVAL : interval; }
    var timer = null;
    var isAnimating = false;

    // v90b — Hero intro video controller. Ensures the reel:
    //  (1) starts IMMEDIATELY on first paint (no delay drawing the user in),
    //  (2) always plays from 0 when Slide 0 is shown,
    //  (3) pauses + resets when the slider leaves Slide 0 so the user never
    //      sees the last 3s end-card freeze (slider advances at 12s; the loop
    //      is otherwise free-running and could surface 12–15s on re-entry).
    var introVideo = slider.querySelector('#lcHeroIntroVideo');
    function playIntroFromStart() {
      if (!introVideo) return;
      try { introVideo.currentTime = 0; } catch (e) {}
      var p = introVideo.play();
      if (p && p.catch) { p.catch(function () {}); }
    }
    function manageHeroVideo(idx) {
      if (!introVideo) return;
      if (idx === 0) { playIntroFromStart(); }
      else { try { introVideo.pause(); } catch (e) {} }
    }
    if (introVideo) {
      // Kick playback the moment metadata/data is ready — don't wait for autoplay heuristics.
      if (introVideo.readyState >= 2) { playIntroFromStart(); }
      introVideo.addEventListener('loadeddata', playIntroFromStart, { once: true });
      introVideo.addEventListener('canplay', playIntroFromStart, { once: true });
      // v94 — Primary 12s advance driver: tie the slide-0 advance to the video's
      // OWN playback time, not just a wall-clock timer (which could desync with a
      // delayed/paused video or stall behind the hover-pause). The moment the reel
      // crosses 12s, advance to slide 2 so the last 3s end-card is never shown.
      // The logicalIdx===0 guard makes it fire exactly once per slide-0 visit.
      introVideo.addEventListener('timeupdate', function () {
        if (logicalIdx === 0 && introVideo.currentTime >= SLIDE0_ADVANCE_SEC && !isAnimating) {
          next();
        }
      });
    }

    function setTrans(on) {
      track.style.transition = on
        ? 'transform 700ms cubic-bezier(0.4, 0, 0.2, 1)'
        : 'none';
    }
    function setX(pos) {
      track.style.transform = 'translate3d(-' + (pos * 100) + '%, 0, 0)';
    }
    function syncDots(idx) {
      dots.forEach(function (d, i) {
        var on = i === idx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      slides.forEach(function (s) {
        var sIdx = parseInt(s.dataset.slideIndex, 10);
        s.setAttribute('aria-hidden', sIdx === idx ? 'false' : 'true');
        s.classList.toggle('is-active', sIdx === idx && !s.dataset.clone);
      });
      manageHeroVideo(idx);
    }

    // Initial: transition off until first paint, then on
    setTrans(false);
    setX(0);
    manageHeroVideo(0);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { setTrans(true); });
    });

    function next() {
      if (isAnimating) return;
      isAnimating = true;
      domPos++;
      setTrans(true);
      setX(domPos);
      logicalIdx = (logicalIdx + 1) % totalLogical;
      syncDots(logicalIdx);
      // If we just animated TO the clone (last DOM slide), snap back to real 0 after transition
      if (domPos === totalDom - 1) {
        var onEnd = function () {
          track.removeEventListener('transitionend', onEnd);
          setTrans(false);
          domPos = 0;
          setX(0);
          // force layout flush before re-enabling transition
          void track.offsetHeight;
          requestAnimationFrame(function () {
            setTrans(true);
            isAnimating = false;
          });
        };
        track.addEventListener('transitionend', onEnd, { once: true });
      } else {
        var onEndN = function () {
          track.removeEventListener('transitionend', onEndN);
          isAnimating = false;
        };
        track.addEventListener('transitionend', onEndN, { once: true });
      }
    }

    function prev() {
      if (isAnimating) return;
      // From slide 0, snap to clone (domPos = totalDom - 1) without transition,
      // then animate to slide 10 (totalLogical - 1).
      if (domPos === 0) {
        isAnimating = true;
        setTrans(false);
        domPos = totalDom - 1;
        setX(domPos);
        void track.offsetHeight;
        requestAnimationFrame(function () {
          setTrans(true);
          domPos = totalLogical - 1;
          setX(domPos);
          logicalIdx = totalLogical - 1;
          syncDots(logicalIdx);
          var onEnd = function () {
            track.removeEventListener('transitionend', onEnd);
            isAnimating = false;
          };
          track.addEventListener('transitionend', onEnd, { once: true });
        });
        return;
      }
      isAnimating = true;
      domPos--;
      setTrans(true);
      setX(domPos);
      logicalIdx = (logicalIdx - 1 + totalLogical) % totalLogical;
      syncDots(logicalIdx);
      var onEndP = function () {
        track.removeEventListener('transitionend', onEndP);
        isAnimating = false;
      };
      track.addEventListener('transitionend', onEndP, { once: true });
    }

    function jumpTo(targetLogical) {
      if (isAnimating || targetLogical === logicalIdx) return;
      isAnimating = true;
      // Animate directly to target (target maps 1:1 to DOM 0..totalLogical-1)
      // If we're currently on clone (domPos = totalDom - 1), snap to real 0 first
      if (domPos === totalDom - 1) {
        setTrans(false);
        domPos = 0;
        setX(0);
        void track.offsetHeight;
      }
      requestAnimationFrame(function () {
        setTrans(true);
        domPos = targetLogical;
        setX(domPos);
        logicalIdx = targetLogical;
        syncDots(logicalIdx);
        var onEnd = function () {
          track.removeEventListener('transitionend', onEnd);
          isAnimating = false;
        };
        track.addEventListener('transitionend', onEnd, { once: true });
      });
    }

    function start() {
      if (!autoplay) return;
      stop();
      // v90 — per-slide interval via recurring setTimeout (Slide 0 = 12s, others = interval)
      function tick() {
        next();
        timer = setTimeout(tick, intervalFor(logicalIdx));
      }
      timer = setTimeout(tick, intervalFor(logicalIdx));
    }
    function stop() { if (timer) { clearTimeout(timer); clearInterval(timer); timer = null; } }

    // Wire controls
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        jumpTo(parseInt(dot.dataset.dotIndex, 10));
        start();
      });
    });
    navs.forEach(function (nav) {
      nav.addEventListener('click', function () {
        var dir = parseInt(nav.dataset.direction, 10);
        if (dir > 0) next(); else prev();
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Touch swipe
    var sx = 0, sy = 0, dx = 0, dy = 0, swiping = false;
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; dy = 0; swiping = true;
        stop();
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!swiping) return;
        var t = e.touches[0]; dx = t.clientX - sx; dy = t.clientY - sy;
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (!swiping) return; swiping = false;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
        }
        start();
      });
    }

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { prev(); start(); }
      if (e.key === 'ArrowRight') { next(); start(); }
    });

    // Smooth scroll for intro CTA anchor (any [data-cta-anchor])
    slider.querySelectorAll('a[data-cta-anchor="true"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    start();
  });
})();

/* v110 (Mert 2026-08-06) — 'headerin ustune binmis'.
   KOK NEDEN: hero `padding-top: var(--lc-header-h, 44px)` yaziyor ama `--lc-header-h`
   TEMANIN HICBIR YERINDE TANIMLI DEGIL. Yani degisken bir sozdu, atayan taraf hic yoktu
   ve deger her zaman 44px yedegine dusuyordu. Gercek header `position: fixed` ve 81px:
   81 - 44 = 37px'lik binisme tam buradan geliyordu. Sabit bir sayi yazmak da olurdu ama
   header yuksekligi degisirse (logo, ikinci satir, guvenli alan) ayni hata geri gelirdi.

   IKI SINIR, ikisi de bilincli:
   (a) Degisken :root'a DEGIL hero elemanina yaziliyor. Temada bu degiskeni okuyan baska
       yerler varsa hepsi bugun yedege dusuyor; :root'a yazmak onlarin davranisini de
       sessizce degistirirdi.
   (b) Yalniz MOBILDE ataniyor. Masaustu deger (48px) Mert'in kendi ayarladigi bir sayi
       ('hepsi birlikte birazcik yukari ciksin'); dinamige cevirmek o ayari geri alirdi. */
(function () {
  var hero = document.querySelector('.lc-hero-slider');
  var header = document.querySelector('.laco-header');
  if (!hero || !header || !window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 768px)');

  function sync() {
    if (!mq.matches) { hero.style.removeProperty('--lc-header-h'); return; }
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) hero.style.setProperty('--lc-header-h', h + 'px');
  }

  sync();
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync, { passive: true });
  if (window.ResizeObserver) { new ResizeObserver(sync).observe(header); }
})();

  } catch(e) { console.error(e); }
})();
})();
